module.exports = __webpack_public_path__ + "static/media/couches-2.7c8151f2.jpg";